export default {"src":"/_next/static/media/icon_hamburger_freebonuscash.0cb1495a.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};